import React from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";

const NextRuleBtn = (props) => {
  function nextBtnLink() {
    if (props.rulesType) {
      switch (props.rulesType) {
        case "rules":
          if (!props.rulesArray.rules.items[props.ruleId]) {
            return "/signs/1/";
          } else {
            return `/rules/${props.currentRule.id + 1}/`;
          }
        case "signs":
          if (!props.rulesArray.signs.items[props.ruleId]) {
            return "/marks/1/";
          } else {
            return `/signs/${props.currentRule.id + 1}/`;
          }
        case "marks":
          if (!props.rulesArray.marks.items[props.ruleId]) {
            return "/access/1/";
          } else {
            return `/marks/${props.currentRule.id + 1}/`;
          }
        case "access":
          return `/access/${props.currentRule.id + 1}/`;
        default:
          break;
      }
    }
    else return "/"
    
  }

  function onClickNextRule() {
    switch (props.rulesType) {
      case "rules":
        if (!props.rulesArray.rules.items[props.ruleId]) {
          props.setLoadedRule(props.rulesArray.signs.items[0]);
        } else {
          props.setLoadedRule(props.rulesArray.rules.items[props.ruleId]);
        }
        break;
      case "signs":
        if (!props.rulesArray.signs.items[props.ruleId]) {
          props.setLoadedRule(props.rulesArray.marks.items[0]);
        } else props.setLoadedRule(props.rulesArray.signs.items[props.ruleId]);
        break;
      case "marks":
        if (!props.rulesArray.marks.items[props.ruleId]) {
          props.setLoadedRule(props.rulesArray.access.items[0]);
        } else props.setLoadedRule(props.rulesArray.marks.items[props.ruleId]);
        break;
      case "access":
        props.setLoadedRule(props.rulesArray.access.items[props.ruleId]);
        break;
      default:
        break;
    }
    window.scrollTo(0, 0);
  }
  return (
    <>
      {props.rulesType !== "access" || props.ruleId !== 2 ? (
        <div className="controll-buttons pb-4">
          <Link
            onClick={onClickNextRule}
            to={nextBtnLink()}
            className="next-button"
          >
            дальше
          </Link>
        </div>
      ) : (
        " "
      )}
    </>
  );
};

const mapStateToProps = (state) => {
    return {
      rulesType: state.router.location.pathname.split("/")[1],
      ruleId: parseInt(state.router.location.pathname.split("/")[2]),
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      setLoadedRule: (loadedBilet) =>
        dispatch({
          type: actionTypes.SET_LOADED_BILET,
          loadedBilet: loadedBilet,
        }),
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(NextRuleBtn);
